import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import styles from "./FilterModal.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { getAllSubscriptions, setFilters } from "reducer/admin/subscriptionSlice";
import { planOptions, statusOptions } from "constants/constants";
import SelectCustom from "components/common/Select/Select";
import { selectDropdownStyles } from "../constants";

const FilterModal = ({ onClose, search }) => {

  const formDropdownFields = [
    { label: "Subscription Status", key: "subscriptionStatus", options: statusOptions },
    { label: "Plan", key: "plan", options: planOptions },
  ];

  const { filters } = useSelector(
    (state) => state.subscriptions
  );

  const { register, handleSubmit, reset, watch, setValue, control } =
    useForm({
      defaultValues: {
        fromDate: filters.fromDate?.split("T")[0] || "",
        toDate: filters.toDate?.split("T")[0] || "",
        subscriptionStatus: filters.subscriptionStatus || null,
        accountStatus: "",
        plan: filters.plan || null,
      },
    });
  const dispatch = useDispatch();

  const fromDate = watch("fromDate");
  const toDate = watch("toDate");

  const isFilterActive = () => {
    const values = watch();
    return values.fromDate || values.toDate || values.subscriptionStatus || values.plan;
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  // const onSubmit = (data) => {
  //   const { fromDate, toDate, ...rest } = data;
  //   let obj = {
  //     fromDate: fromDate ? new Date(fromDate).toISOString() : null,
  //     toDate: toDate ? new Date(toDate).toISOString() : null,
  //     ...rest,
  //   };
  //   dispatch(getAllSubscriptions({ search, ...obj }));
  //   onClose();
  // };

  const onSubmit = (data) => {
    const payload = {
      ...data,
      fromDate: data.fromDate ? new Date(data.fromDate).toISOString() : "",
      toDate: data.toDate ? new Date(data.toDate).toISOString() : "",
    };
    dispatch(setFilters(payload));
    dispatch(getAllSubscriptions({ pageSelected: 1, search: search, filters: payload }));
    onClose();
  };

  // const handleResetAll = () => {
  //   reset({
  //     fromDate: "",
  //     toDate: "",
  //     subscriptionStatus: "",
  //     accountStatus: "",
  //     plan: "",
  //   });
  // };

  const resetAll = () => {
    reset({
      fromDate: "",
      toDate: "",
      subscriptionStatus: "",
      plan: ""
    });
    dispatch(setFilters({ fromDate: "", toDate: "", subscriptionStatus: "", flaggedStatus: "" }));
    dispatch(getAllSubscriptions({ pageSelected: 1, search: search, filters: {} }));
    onClose();
  };

  const handleDateReset = () => {
    setValue("fromDate", "");
    setValue("toDate", "");
  };

  return (
    <div
      className={styles.overlay}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className={styles.modal}>
        <div className={styles.dragBar} />

        <p className={styles.title}>Filter by:</p>

        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Date Range */}
          <div className={styles.section}>
            <div className={styles.labelRow}>
              <label>Date Range</label>
              <button type="button" onClick={handleDateReset}>
                Reset
              </button>
            </div>
            <div className={styles.dateRow}>
              <input
                type="date"
                {...register("fromDate")}
                max={toDate || undefined}
              />
              <input
                type="date"
                {...register("toDate")}
                min={fromDate || undefined}
              />
            </div>
          </div>

          {formDropdownFields?.map(({ label, key, options }) => (
            <div className={styles.section} key={key}>
              <div className={styles.labelRow}>
                <span>{label}</span>
                <button
                  type="button"
                  onClick={() => {
                    setValue(key, "");
                  }}
                >
                  Reset
                </button>
              </div>
              <Controller
                name={key}
                control={control}
                render={({ field }) => {
                  let selectedOption;
                  if (field.value) {
                    selectedOption = options.find(option => option.value === field.value);
                  } else {
                    selectedOption = ""
                  }
                  return (
                    <SelectCustom
                      {...field}
                      options={options}
                      value={selectedOption}
                      styles={selectDropdownStyles()}
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption?.value);
                      }}
                    />
                  );
                }}
              />
            </div>
          ))}

          {/* Footer */}
          <div className={styles.footer}>
            <button
              type="button"
              className={`${styles.resetBtn} ${!isFilterActive() ? 'disabled' : ''}`}
              onClick={resetAll}
              disabled={!isFilterActive()}
            >
              Reset All
            </button>
            <button type="submit" className={`${styles.applyBtn} ${!isFilterActive() ? 'disabled' : ''}`} disabled={!isFilterActive()}>
              Apply Filters
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FilterModal;
